module.exports = __webpack_public_path__ + "media/images/mb-1d99b563a85e35117c8c0c6ddd24082d.png";